import * as Yup from 'yup';
import { StepMainProductionSiteForm } from './step-main-production-site-types';

export const stepMainProductionSiteSchema = () =>
  Yup.object<StepMainProductionSiteForm>().shape({
    mainProductionSite: Yup.mixed().nullable().required('Povinné pole'),
  });
